import { render, staticRenderFns } from "./PaiementRetraitNews.vue?vue&type=template&id=12a1883c&"
import script from "./PaiementRetraitNews.vue?vue&type=script&lang=js&"
export * from "./PaiementRetraitNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports